// Sorting Code Starts
const addSorting = filter=>{

    let newSort = [];
   newSort.push(
    {
        field: "relevance",
        order: "asc"
    },
     {
        field: "product_product_search_ranking_new_custom:float",
        order: "asc"
    },
   ),
   
    filter.sort = newSort
}
// Sorting Code Ends

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      console.log("WIZZY INIT");
      data.filters.configs.layout = "v1";
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 2e3,
        mobile: 2e3,
      };
      return data;
    }
  );
  //Inventory source code start
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      payload.inventorySources = JSON.stringify([
        {
          key:
            typeof localStorage.store_id === "undefined"
              ? "SC_india"
              : localStorage.store_id,
          inStock: ["true", "false"],
        },
      ]);
      return payload;
    }
  );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      payload.inventorySources = JSON.stringify([
        {
          key:
            typeof localStorage.store_id === "undefined"
              ? "SC_india"
              : localStorage.store_id,
          inStock: ["true", "false"],
        },
      ]);
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      payload.filters.inventorySources = [
        {
          key:
            typeof localStorage.store_id === "undefined"
              ? "SC_india"
              : localStorage.store_id,
          inStock: ["true", "false"],
        },
      ];
      return payload;
    }
  );
  //Inventory source code End

  // Sorting Code Starts
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      addSorting(data);
      return data;
    }
  );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      if(data.sort&&data.sort.length&&data.sort[0].field=='relevance'){
        addSorting(data);
      }
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      if(data.filters.sort&&data.filters.sort.length&&data.filters.sort[0].field=='relevance'&&!(data.filters.type==="AUTOCOMPLETE_DEFAULT")&&!window.wizzyConfig.common.isOnCategoryPage)
      {
        addSorting(data.filters);
      }
      return data;
    }
  );
  // Sorting Code Ends
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
        
      //   $('body .opendropdown').click(function() {
      //     //console.log("inside");
      //     if ($('.opendropdown').hasClass("active")) {
      //        $('.opendropdown').removeClass('active');
      //       //$(".scope").removeClass('active');
      //       $(".scope").html('');
      //     }
      //     //console.log("hellllllll")
      //   const prodHandle = $(this).attr('data-handle');
      //   const clickedElement = $(this);
      //   $.get("/products/" + prodHandle + "/?view=variantpopup", function (data) {
      //     //console.log("data", data);
      //     clickedElement.next('.multivariant_container').html(data);
      //   });
      //   const $dropdown = $(this);
      //   const $parent = $dropdown.next('.multivariant_container');
      //     //console.log("$parent", $parent);
      //   if ($parent.length) {
      //     //alert("as");
      //       $parent.toggleClass('active');
      //      $dropdown.toggleClass('active');
      //       // const parentOffset = $parent.offset();
      //       // const dropdownOffset = $dropdown.offset();
      //       // const offsetTop = dropdownOffset.top - parentOffset.top;
      //       // const offsetLeft = dropdownOffset.left - parentOffset.left;
      //       //console.log($parent.offset(),'hi', $dropdown.offset());
      //       //$(".scope.horizontal-scope.active").css("top", offsetTop);
      //       //$(".scope.horizontal-scope.active").css("left", offsetLeft);
      //   }
        
      // });
      // var $el = $("body .product-dropdown");
      //   var $ee = $("body .scope");
      //   const $dropdown1 = $("body .opendropdown");
      //   $(document).on("click", function (e) {
      //     // Check if the clicked element is *outside* .product-dropdown and .opendropdown
      //     if (
      //       !$(e.target).closest(".product-dropdown").length &&
      //       !$(e.target).closest(".opendropdown").length &&
      //       !$(e.target).closest(".quick-add").length &&
      //       $ee.hasClass("active")
      //     ) {
      //       //console.log("if");
      //       $ee.removeClass("active");
      //       $ee.html("");
      //       $dropdown1.removeClass("active");
      //     }
      //   });
       // Delegate the click to prevent multiple bindings
  $('body').off('click', '.opendropdown').on('click', '.opendropdown', function (e) {
    e.stopPropagation(); // Prevent document click event from immediately closing it

    const $clickedDropdown = $(this);
    const $variantContainer = $clickedDropdown.next('.multivariant_container');

    // Close all other open dropdowns
    $('.opendropdown').not($clickedDropdown).removeClass('active');
    $('.multivariant_container').not($variantContainer).removeClass('active').html('');

    const prodHandle = $clickedDropdown.attr('data-handle');

    // Toggle active state for clicked dropdown
    $clickedDropdown.toggleClass('active');
    $variantContainer.toggleClass('active');

    if ($variantContainer.hasClass('active')) {
      // Load variant popup HTML via AJAX
      $.get(`/products/${prodHandle}/?view=variantpopup`, function (data) {
        $variantContainer.html(data);
      });
    } else {
      $variantContainer.html('');
    }
  });

  // Handle click outside to close any open dropdown
  $(document).off('click.variantpopup').on('click.variantpopup', function (e) {
    if (
      !$(e.target).closest('.product-dropdown').length &&
      !$(e.target).closest('.opendropdown').length &&
      !$(e.target).closest('.quick-add').length
    ) {
      $('.multivariant_container').removeClass('active').html('');
      $('.opendropdown').removeClass('active');
    }
  });
      const currentPath = window.location.pathname;
      const navLinks = document.querySelectorAll('nav.header__inline-menu .list-menu__item');
    
      let matchedNavItem = null;
    
      navLinks.forEach(link => {
        var tempLink = link.getAttribute("onclick").match(/'([^']+)'/)[1];
        if (tempLink === currentPath) {
          matchedNavItem = link;
        }
      });

      if (!matchedNavItem) {
        var tempChildLinks = document.querySelectorAll('nav.header__inline-menu .mega-menu__content .mega-menu__link.link');

        if (tempChildLinks) {
          tempChildLinks.forEach(link => {
            var tempLink = link.getAttribute("href");
            if (tempLink === currentPath) {
              matchedNavItem = link;
            }
          });
        }
      }

      if (matchedNavItem) {
        var parentNavItem = matchedNavItem.closest('details.mega-menu');
        if (parentNavItem) {
          var childNavItems = parentNavItem.querySelector('.mega-menu__content');
          if (childNavItems) {
            var categoryFilterWrapper = document.querySelector('.wizzy-facet-body.facet-body-product_main_category_custom');
            if (categoryFilterWrapper) {
              categoryFilterWrapper.innerHTML = childNavItems.innerHTML;
            }
          }
        }
      }

      // $('.wizzy-facet-list-block .mega-menu__link--level-2').click(function (e) {
      // e.preventDefault(); // Prevent link navigation

      // // Get the next sibling <ul class="list-unstyled">
      // var $submenu = $(this).next('.wizzy-facet-list-block .list-unstyled');

      // // Toggle visibility
      // $submenu.slideToggle('fast');

      // // Optional: close other open submenus (accordion behavior)
      // $('.wizzy-facet-list-block .mega-menu__link--level-2').not(this).next('.wizzy-facet-list-block .list-unstyled').slideUp('fast');
      // });
      $('.wizzy-facet-list-block .mega-menu__link--level-2').click(function (e) {
          e.preventDefault(); // Prevent link navigation

          // Get the next sibling <ul class="list-unstyled">
          var $submenu = $(this).next('.list-unstyled');

          // Toggle visibility
          $submenu.slideToggle('fast');

          // Optional: close other open submenus (accordion behavior)
          $('.wizzy-facet-list-block .mega-menu__link--level-2').not(this).next('.list-unstyled').slideUp('fast');
        });
      if (window.innerWidth > 768) {
        const sortWrapper = document.querySelector('.search-filters-top-wrapper .wizzy-search-sort-wrapper');
        if (sortWrapper) {
          const sortWrapperClone = sortWrapper.cloneNode(true);
          const sortInFiltersWrapper = document.querySelector('.wizzy-search-filters-left .wizzy-sort-desktop');
  
          if (sortWrapperClone && sortInFiltersWrapper) {
            sortInFiltersWrapper.innerHTML = "";
            sortInFiltersWrapper.appendChild(sortWrapperClone);
          }
        }
      }
      if (window.innerWidth < 768) {
  var filterBlocks = document.querySelectorAll('.wizzy-filters-facet-block');
  var filterBlockss = document.querySelectorAll('.wizzy-facet-head');

  filterBlockss.forEach(function (block, index) {
    block.addEventListener('click', function () {
      if (block.classList.contains('collapsed')) {
        // Collapse all headers
        filterBlockss.forEach(function (el) {
          el.classList.add('collapsed');
        });
        // Collapse all content blocks
        filterBlocks.forEach(function (el) {
          el.classList.add('collapsed');
        });

        // Open the clicked one
        block.classList.remove('collapsed');
        filterBlocks[index].classList.remove('collapsed');
      } else {
        // Collapse this one
        block.classList.add('collapsed');
        filterBlocks[index].classList.add('collapsed');
      }
    });
  });
}

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {

      if (window.innerWidth > 768) {
        const sortWrapper = document.querySelector('.search-filters-top-wrapper .wizzy-search-sort-wrapper');
        if (sortWrapper) {
          const sortWrapperClone = sortWrapper.cloneNode(true);
          const sortInFiltersWrapper = document.querySelector('.wizzy-search-filters-left .wizzy-sort-desktop');
  
          if (sortWrapperClone && sortInFiltersWrapper) {
            sortInFiltersWrapper.innerHTML = "";
            sortInFiltersWrapper.appendChild(sortWrapperClone);
          }
        }
      }
      const currentPath = window.location.pathname;
      const navLinks = document.querySelectorAll('nav.header__inline-menu .list-menu__item');
    
      let matchedNavItem = null;
    
      navLinks.forEach(link => {
        var tempLink = link.getAttribute("onclick").match(/'([^']+)'/)[1];
        if (tempLink === currentPath) {
          matchedNavItem = link;
        }
      });

      if (!matchedNavItem) {
        var tempChildLinks = document.querySelectorAll('nav.header__inline-menu .mega-menu__content .mega-menu__link.link');

        if (tempChildLinks) {
          tempChildLinks.forEach(link => {
            var tempLink = link.getAttribute("href");
            if (tempLink === currentPath) {
              matchedNavItem = link;
            }
          });
        }
      }

      if (matchedNavItem) {
        var parentNavItem = matchedNavItem.closest('details.mega-menu');
        if (parentNavItem) {
          var childNavItems = parentNavItem.querySelector('.mega-menu__content');
          if (childNavItems) {
            var categoryFilterWrapper = document.querySelector('.wizzy-facet-body.facet-body-product_main_category_custom');
            if (categoryFilterWrapper) {
              categoryFilterWrapper.innerHTML = childNavItems.innerHTML;
            }
          }
        }
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      //console.log("Wizzy AFTER_PRODUCTS_TRANSFORMED" ,data);
      data.forEach(product => {
        // console.log("Wizzy product id", product.id);
        // console.log("Wizzy product singleVarientGroupId", product.singleVarientGroupId);
        product.handle = product.url.split('/').pop();
        product.inStock = product.inStock;
        const productIdc = window.variantID.split(",");
        const productId = product.id.toString();
        const matched = productIdc.find(id => id.startsWith(productId + "-"));
        if (matched) {
            const quantity1 = matched.split("-")[1];
            product.hideAddButton = "true"; 
            product.defaultQty = quantity1;
          }
        //console.log("product.attributes", product.attributes);
        product.attributes.forEach(attribute => {
          if(attribute.id === "product_product_swatch_custom"){
            product.packSizes = attribute.values[0].value[0];
          }
          if(attribute.id === "product_size_custom"){
            product.capacityUnit = attribute.values[0].value[0];
          }
          if(attribute.id === "product_max_quantity_custom"){
            product.maxQuantity = attribute.values[0].value[0];
          }
          if(attribute.id === "product_veg_nonveg_custom"){
            if(attribute.values[0].value[0] == 'Non Veg'){
              product.vegOrNonVeg = 'non-veg-box';
            }else{
              product.vegOrNonVeg = 'veg-box';
            }
          }
          if(attribute.id === "product_stock_quantity"){
            var productQuantity = attribute.values[0].value[0];
            if (productQuantity < product.maxQuantity) {
              product.maxQuantity = productQuantity;
            }
          }
          if (attribute.id === "product_tags") {
            var rawTags = attribute.values[0].value[0]; // first string from array
            var tagsArray = rawTags.split(",").map(tag => tag.trim()); // split & clean

            if (tagsArray.includes("SC_india")) {
              product.IndiaTagAvailable = true;
            } else {
              product.IndiaTagAvailable = false; // optional
            }

            console.log("Parsed tags:", tagsArray);
          }

        });
      });
      return data;
    }, 1
  );


  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        $('body').addClass('wizzy-search-results-rendered');
      return data;
    }
  );

};

(function () {
  const WIZZY_STORE_KEY = 'wizzy_store';

  function readStore(storage) {
    try {
      return JSON.parse(storage.getItem(WIZZY_STORE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeStore(storage, data) {
    try {
      storage.setItem(WIZZY_STORE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function uuid() {
    return crypto.randomUUID();
  }

  // Same priority as WizzyUser.getId()
  function getWizzyUserId() {
    const fromConfig = window.wizzyUserConfig?.loggedInUser?.id;
    if (fromConfig) return fromConfig;

    const local = readStore(localStorage);
    if (local.USER_ID) return local.USER_ID;

    const newId = uuid();
    local.USER_ID = newId;
    writeStore(localStorage, local);

    if (window.wizzyUserConfig?.loggedInUser) {
      window.wizzyUserConfig.loggedInUser.id = newId;
    }

    return newId;
  }

  // Same priority as WizzySession.getId()
  function getWizzySessionId() {
    const local = readStore(localStorage);
    const sessionObj = local.SESSION_ID;

    if (sessionObj?.sessionId && new Date() < new Date(sessionObj.expiresAt)) {
      const session = readStore(sessionStorage);
      session.SESSION_ID = sessionObj.sessionId;
      writeStore(sessionStorage, session);
      return sessionObj.sessionId;
    }

    const session = readStore(sessionStorage);
    if (session.SESSION_ID) {
      return typeof session.SESSION_ID === 'string'
        ? session.SESSION_ID
        : session.SESSION_ID.sessionId;
    }

    const newSessionId = uuid();
    const expiresAt = new Date(Date.now() + 60 * 60 * 1000).toUTCString();

    local.SESSION_ID = { sessionId: newSessionId, expiresAt };
    session.SESSION_ID = newSessionId;
    writeStore(localStorage, local);
    writeStore(sessionStorage, session);

    return newSessionId;
  }

  // Same logic as WizzyTags in wizzy bundle
  function isMobile() {
    const ua = navigator.userAgent || navigator.vendor || '';
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(ua)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(ua.substr(0, 4));
  }

  function isTablet() {
    const ua = navigator.userAgent || '';
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(ua);
  }

  function getDeviceTag() {
    if (isMobile()) return 'Device:Mobile';
    if (isTablet()) return 'Device:Tablet';
    return 'Device:Desktop';
  }

  function getPlatformTag() {
    const ua = navigator.userAgent;
    const platform = navigator.platform;

    if (['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].includes(platform)) return 'Platform:MacOS';
    if (['iPhone', 'iPad', 'iPod'].includes(platform)) return 'Platform:iOS';
    if (['Win32', 'Win64', 'Windows', 'WinCE'].includes(platform)) return 'Platform:Windows';
    if (/Android/.test(ua)) return 'Platform:Android';
    if (/Linux/.test(platform)) return 'Platform:Linux';
    return 'Platform:Other';
  }

  function getWizzyTags() {
    return [getDeviceTag(), getPlatformTag()].join(',');
  }

  function getCommonHeaders() {
    return {
      'x-api-key': window.wizzyConfig.credentials.apiKey,
      'x-store-id': window.wizzyConfig.credentials.storeId,
      'x-request-id': uuid(),
      'x-wizzy-userId': getWizzyUserId(),
      'x-wizzy-tags': getWizzyTags(),
      'x-wizzy-sessionId': getWizzySessionId(),
    };
  }

  function getProductCardFromClick(clickedEl) {
    return clickedEl.closest('.wizzy-result-product');
  }

  function getItemIdFromCard(card) {
    if (!card) return null;
  return card.dataset.groupid || card.dataset.groupId || card.dataset.id || null;
  }

  function getPositionFromCard(card) {
    if (!card?.parentElement) return null;
    return Array.from(card.parentElement.querySelectorAll('.wizzy-result-product')).indexOf(card) + 1;
  }

  // Optional: keep native PDP flow working too
  function storeClickedProduct(itemId, searchResponseId, position, source) {
    const store = readStore(localStorage);
    store.CLICKED_PRODUCTS = store.CLICKED_PRODUCTS || {};
    store.CLICKED_PRODUCTS[itemId] = {
      productId: itemId,
      responseId: searchResponseId,
      position,
      source,
    };
    writeStore(localStorage, store);
  }

  window.trackWizzyProductClick = function (clickedEl, options = {}) {
    const card = getProductCardFromClick(clickedEl);
    const itemId = getItemIdFromCard(card);
    if (!itemId) return;

    const position = getPositionFromCard(card);
    const searchResponseId = window.wizzyConfig?.pageStore?.lastResponseId || '';
    const source = options.source || 'SEARCH_RESULTS';
    const sendNow = options.sendNow !== false; // default true for your custom use case

    storeClickedProduct(itemId, searchResponseId, position, source);

    if (!sendNow) return;

    const endpoint = window.wizzyConfig?.analytics?.endpoints?.clicks;
    if (!endpoint) return;

    const payload = {
      type: 'click',
      headers: getCommonHeaders(),
      data: {
        name: 'Search Results Clicked',
        searchResponseId,
        items: [{ itemId: String(itemId), position }],
        source,
      },
    };

    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        // same as native sessions/clicks flow
        if (data?.userId && window.wizzyUserConfig?.loggedInUser) {
          window.wizzyUserConfig.loggedInUser.id = data.userId;

          const store = readStore(localStorage);
          store.USER_ID = data.userId;
          writeStore(localStorage, store);
        }
        return data;
      });
  };
})();

document.addEventListener('click', function (e) {
  const target = e.target.closest('.quick-add__submit');
  if (!target) return;

  window.trackWizzyProductClick(target, {
    source: 'SEARCH_RESULTS',
    sendNow: true, // send immediately
  });
});
